export default Object.freeze({
    BOILER: 'boiler',
    COOLING: 'cooling',
    EVAPORATIVE: 'evaporative',
    STEAM: 'steam',
    CLOSED: 'closed',
    CONDENSATE: 'condensate',
    SOFTENER: 'softener',
    DEALKALIZER: 'dealkalizer',
    REVERSE: 'reverse',
    MAKEUP: 'make-up',
    WASTE: 'waste',
    DEMIN: 'demin',
    DOMESTIC: 'domestic',
    FOUNTAIN: 'fountain',
    POLISHER: 'polisher',
    GENERIC: 'generic',
    COUNTER: 'counter',
    WATERVALE: 'water-valve',
    ACUNIT: 'ac-unit',
    RADIATOR: 'radiator',
    HEATINGELEMENT: 'heating-element',
    WATERFILTER: 'water-filter',
    CONTROLLER: 'controller',
    FEEDWATERDEAERATOR: 'feedwater-deaerator',
});
